import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Modal, Form, Input, Row, Col, Select, message, AutoComplete, Spin, Skeleton, Checkbox, DatePicker, Empty } from 'antd';
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getAllCustomFieldByCompanyAndEntity, findAllCustomOptionsByDropdown } from '../../../Api/Services/CustomeUIApiService';
import { convertCurrency } from '../Filters/FilterConditions';
import { getAllUsersData, getCountryData, getCityData, getStateData } from '../../../Api/Services/CommonApiService'
import { FetchAllLead, massUpdateLead, massDeleteLeads, convertLeadToContact } from '../../../Api/Services/LeadApiServices'
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { ChangeOwnerIcon, ConvertIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, nameOnChangeValidator, validateZipCode, validateUrlField, validateEmailField, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

export function validateNumberField(value) {
    if (value === undefined || value === null || value === '') return null;
    const allowedRegex = /^[0-9]*$/;
    if (!allowedRegex.test(value)) return 'Only numbers are allowed';
    return null;
}

export function validateCurrencyField(value, decimalPlace = 2) {
    if (value === undefined || value === null || value === '') return null;
    const basicNumberCheck = /^\d+(\.\d*)?$/;
    if (!basicNumberCheck.test(value)) return 'Please enter a valid number';
    if (value.endsWith('.')) return null;
    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlace}})?$`);
    if (!decimalRegex.test(value)) return `Only up to ${decimalPlace} decimal place${decimalPlace > 1 ? 's' : ''} are allowed`;
    return null;
}

export function validatePercentageField(value, decimalPlace = 2) {
    if (value === undefined || value === null || value === '') return null;
    const basicNumberCheck = /^\d+(\.\d*)?$/;
    if (!basicNumberCheck.test(value)) return 'Please enter a valid number';
    if (value.endsWith('.')) return null;
    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlace}})?$`);
    if (!decimalRegex.test(value)) return `Only up to ${decimalPlace} decimal place${decimalPlace > 1 ? 's' : ''} are allowed`;
    const num = Number(value);
    if (num < 0 || num > 100) return 'Percentage must be between 0 and 100';
    return null;
}

const Popup = ({ popup, setPopup, GetAll, popupType, values, action, setStates, assignOwner, pageType, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const history = useHistory();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'leads')?.customEntityId
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const ProfileData = localData.profile
    const profile = ProfileData
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const [open, setOpen] = useState(false)
    const [users, setUsers] = useState([])
    const [field1, setField1] = useState()
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [allCountry, setAllCountry] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [stateData, setStateData] = useState([])
    const [cityData, setCityData] = useState([])
    const [account2, setAccount2] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [editAttributes, setEditAttributes] = useState([])
    const [selectBoxes, setSelectBoxes] = useState();
    const [dropdownOptions, setDropdownOptions] = useState({});
    const [dropdownLoading, setDropdownLoading] = useState({});
    const DEFAULT_DROPDOWN_FIELDS = ["accountName", "leadOwner", "country", "state", "city"];
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete query' };
            }
            if (query.visible !== "No") {
                if (
                    query.editedValue === undefined ||
                    query.editedValue === null ||
                    query.editedValue === ""
                ) {
                    return { isValid: false, message: 'Incomplete query' };
                }
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setPopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setStates({ selectedRowKeys: [] })
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            const options = response.map((option) => (
                <Option key={option.countryId} value={option.country}>
                    {option.country}
                </Option>))
            setAllCountry(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
        setPopup(false)
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (popupType.includes("Delete")) {
            const payload = {
                leadIds: values
            }
            try {
                const response = await massDeleteLeads(payload)
                if (response.status === 200) {
                    if (popupType === "Delete") {
                        if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                            setErrorData(response.data);
                            setIsModalVisible(true);
                            dispatch(setEditCall(false))
                            loadingRef.current = false;
                            setDelteClick(false)
                        } else {
                            const isAutomation = response.data[0].entityMessage === AutomationMessage;
                            const isApproval = response.data[0].entityMessage === ApprovalMessage;
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            if (isApproval) {
                                successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            } else if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].entityMessage);
                            } else {
                                message.success(
                                    <span>
                                        Lead <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                    </span>
                                );
                            }
                            history.push('/Home/leads')
                            setPopup(false)
                        }
                    } else {
                        const allUpdatedSuccessfully = response.data.every(item =>
                            item.entityMessage === "Lead Has Deleted Successfully"
                        );
                        if (allUpdatedSuccessfully) {
                            dispatch(setEditCall(false))
                            message.success(`${values.length} records deleted successful`);
                            GetAll();
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                            setPopup(false)
                            loadingRef.current = false;
                            setDelteClick(false)
                            return;
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        dispatch(setEditCall(false))
                        setErrorData(response.data);
                        setIsModalVisible(true);
                    }
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
        else {
            const payload =
            {
                leads: values
            }
            try {
                const response = await convertLeadToContact(payload);
                if (response.status === 201) {
                    setTimeout(() => {
                        FetchAllAccount()
                    }, 1000);
                    if (response.data.success.length > 0 && response.data.error.length === 0) {
                        if (action === "ConvertNav") {
                            dispatch(setExPoCall(true))
                            successMessage('Lead converted to contact',
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Party.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>
                                        Congratulations! Your lead, <strong>{response.data.success}</strong>, has been converted into a contact. You&lsquo;re one step closer to closing the deal!
                                    </span>
                                </>)
                            setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            setPopup(false);
                            loadingRef.current = false;
                            setDelteClick(false)
                            history.push('/Home/leads');
                            // message.success(`${response.data.success} has been converted to a contact`)
                        }
                        else {
                            GetAll();
                            loadingRef.current = false;
                            setDelteClick(false)
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                            setPopup(false);
                            dispatch(setExPoCall(true));
                            successMessage("Leads converted to contacts",
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Party.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span> Congratulations! Your selected leads have been converted into contacts. You&lsquo;re one step closer to closing the deal!</span>
                                </>)
                            setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            // message.success("Selected leads have been successfully converted to contacts")
                        }
                    }
                    else if (response.data.success.length > 0 && response.data.error.length > 0) {
                        dispatch(setExPoCall(true));
                        loadingRef.current = false;
                        setDelteClick(false)
                        successMessage("Leads converted to contacts",
                            <>
                                <img
                                    src={require('../../../static/img/defaultImages/Party.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span> Congratulations! Your selected leads have been converted into contacts. You&lsquo;re one step closer to closing the deal!</span>
                            </>)
                        setTimeout(() => dispatch(setExPoCall(false)), 3000);
                        // message.info("Selected leads have been successfully converted to contacts")
                        setOpen(false)
                        // setOpen(true)
                        GetAll();
                    }
                    // else if (response.data.success.length === 0 && response.data.error.length > 0) {
                    //     message.error("No leads with qualified accounts found")
                    //     setOpen(true)
                    //     GetAll();
                    // }
                    else {
                        loadingRef.current = false;
                        setDelteClick(false)
                        GetAll();
                        setPopup(false);
                        message.error("Issue with converting")
                        // message.info("No leads with qualified accounts found")
                    }
                    // setData(response.data)
                    dispatch(setEditCall(false))
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
    }
    const onFromSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            leadIds: values,
        }
        if (popupType === "Change Owner") {
            formData.leadOwner = field1;
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateLead(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Lead <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                setPopup(false)
                                if (!isApproval && assignOwner !== field1) {
                                    history.push('/Home/leads');
                                }
                                if (assignOwner === field1) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Lead Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setPopup(false)
                                return;
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                            dispatch(setEditCall(false))
                        }
                    }
                }
                catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            } else {
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            const flatFields = await selectBoxes.reduce(async (accPromise, item) => {
                const acc = await accPromise;
                const { editedField, editedValue, visible, Key } = item;
                if (!editedField) return acc;
                let value = null;
                switch (Key) {
                    case 'FileUpload':
                        value = normalizeValue(editedValue ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = editedValue || [];
                        break;
                    case 'Date':
                        value = editedValue;
                        // value = editedValue ? moment(editedValue).format("YYYY-MM-DD") : null;
                        break;
                    case 'Number':
                    case 'Percentage':
                        value = editedValue !== undefined && editedValue !== "" ? Number(editedValue) : null;
                        break;
                    case 'Currency':
                        value = editedValue
                            ? await convertCurrency(ConvertRate, Number(editedValue))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = editedValue && editedValue.length > 0 ? editedValue.join(",") : null;
                        break;
                    case 'CheckBox':
                        value = editedValue ?? false;
                        break;
                    default:
                        value = normalizeValue(editedValue ?? null);
                        break;
                }
                if (visible === "No") {
                    acc[editedField] = normalizeValue(value);
                    return acc;
                }
                if (editedValue != null) {
                    acc[editedField] = normalizeValue(value);
                }
                return acc;
            }, {});
            const finalPayload = Object.entries(flatFields).reduce((acc, [key, value]) => {
                const fieldInfo = editAttributes.find(f => f.fieldKey === key);
                if (!fieldInfo) return acc;
                if (fieldInfo.customFieldType === "Default") {
                    acc[key] = value;
                } else {
                    if (!acc.customFieldValues) acc.customFieldValues = [];
                    acc.customFieldValues.push({
                        entityId: fieldInfo.entityId,
                        fieldId: fieldInfo.fieldId,
                        value
                    });
                }
                return acc;
            }, {});
            Object.assign(formData, finalPayload);
            try {
                const response = await massUpdateLead(formData)
                if (response.status === 200) {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.message === "Lead Has Updated Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        loadingRef.current = false;
                        setDelteClick(false)
                        dispatch(setEditCall(false))
                        if (pageType === "Listing") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                        message.success("Data updated for selected records")
                        GetAll()
                        setPopup(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                    dispatch(setEditCall(false))
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const fetchCustomGroupsAndFields = async () => {
        try {
            const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
            const allFields = [...allFieldsRaw].sort((a, b) => {
                if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
                    return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
                }
                return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            });
            const removeFields = ["firstName", "lastName", "primaryEmail"];
            const removeFieldsTypes = ["FileUpload", "MultiFileUpload"];
            const filteredAttributes = allFields.filter(
                item => !removeFields.includes(item.fieldKey) && !removeFieldsTypes.includes(item.fieldType)
            );
            const structure = filteredAttributes.filter((item) => item.fieldVisible === 'Yes').map((field) => ({
                fieldId: field.fieldId,
                entityId: field.entityId,
                customFieldValueId: null,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                customFieldType: field.customFieldType,
            }));
            setEditAttributes(structure);
            if (structure.length > 0) {
                const firstField = structure[0];
                setSelectBoxes([{
                    editedField: structure[0].fieldKey,
                    editedValue: structure[0].fieldType === "CheckBox" ? false : null,
                    Key: structure[0].fieldType
                }]);
                const isCustomDropdown =
                    (firstField.fieldType === 'Dropdown' || firstField?.fieldType === 'Multi-Dropdown') &&
                    firstField.dropdownId &&
                    !DEFAULT_DROPDOWN_FIELDS.includes(firstField.fieldKey);

                if (isCustomDropdown) {
                    setDropdownLoading(prev => ({ ...prev, [firstField.fieldKey]: true }));
                    try {
                        const res = await findAllCustomOptionsByDropdown(firstField.dropdownId);
                        setDropdownOptions(prev => ({ ...prev, [firstField.fieldKey]: res }));
                    } catch (err) {
                        setDropdownOptions(prev => ({ ...prev, [firstField.fieldKey]: [] }));
                    } finally {
                        setDropdownLoading(prev => ({ ...prev, [firstField.fieldKey]: false }));
                    }
                }
            } else {
                setSelectBoxes([]);
            }
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    async function fetchLeadAndAccount() {
        try {
            // Run both requests in parallel
            const [leads, accounts] = await Promise.all([
                FetchAllLead(),
                FetchAllAccount()
            ]);

            return { leads, accounts };
        } catch (error) {
            message.error(error);
            throw error; // rethrow so caller knows it failed
        }
    }
    async function LeadApi() {
        try {
            const { leads, accounts } = await fetchLeadAndAccount();
            const leadAccounts = leads.map(item => ({
                value: item.accountName,
                key: item.accountName,
            }));
            const apiAccounts = accounts.map(item => ({
                value: item.accountName,
                key: item.accountName,
            }));
            const mergedAccounts = Array.from(
                new Map(
                    [...leadAccounts, ...apiAccounts].map(item => [item.value, item])
                ).values()
            );
            setAccount2(mergedAccounts)
        } catch (error) {
            message.error(error)
        }
    }
    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField1(assignOwner)
            form.setFieldsValue({
                leadOwner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField1(profile.userId)
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            LeadApi(),
            getCountry(),
            fetchCustomGroupsAndFields(),
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail(),
            fetchCustomGroupsAndFields(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (popup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [popup])
    const handleLeadOwner = (value) => {
        setField1(value)
    }
    const getRefreshtheTable = () => {
        setPopup(false)
        if (pageType === "Listing") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (action === "DeleteNav") {
            history.push('/Home/leads')
        }
    }
    const handleViewChange = async (index, fieldName, value, key, option) => {
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: value,
                editedValue: key === "CheckBox" ? false : null,
                Key: key,
            };
            const selectedAttribute = editAttributes.find(attr => attr.fieldKey === value);
            const isCustomDropdown =
                (selectedAttribute?.fieldType === 'Dropdown' || selectedAttribute?.fieldType === 'Multi-Dropdown') &&
                selectedAttribute?.dropdownId &&
                !DEFAULT_DROPDOWN_FIELDS.includes(value);
            if (isCustomDropdown) {
                setDropdownLoading(prev => ({ ...prev, [selectedAttribute.fieldKey]: true }));
                try {
                    const res = await findAllCustomOptionsByDropdown(selectedAttribute.dropdownId);
                    setDropdownOptions(prev => ({ ...prev, [selectedAttribute.fieldKey]: res }));
                } catch (err) {
                    setDropdownOptions(prev => ({ ...prev, [selectedAttribute.fieldKey]: [] }));
                } finally {
                    setDropdownLoading(prev => ({ ...prev, [selectedAttribute.fieldKey]: false }));
                }
            }
            if (value === "country" || value === "state" || value === "city" || value === "street" || value === "postcode") {
                const countryField = {
                    editedField: "country",
                    editedValue: null,
                    Key: null,
                };
                const stateField = {
                    editedField: "state",
                    editedValue: null,
                    Key: null,
                };
                const cityField = {
                    editedField: "city",
                    editedValue: null,
                    Key: null,
                };
                const streetField = {
                    editedField: "street",
                    editedValue: null,
                    Key: null,
                };
                if (value === "country") {
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setStateData([])
                    setCityData([])
                }
                if (value === "state") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== 'city' && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField);

                    setStateData([])
                    setCityData([])
                }
                if (value === "city") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField);
                }
                if (value === "street") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField);
                }
                if (value === "postcode") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField, streetField);
                }
            } else {
                updatedFormData = updatedFormData.filter(
                    item => !["country", "state", "city", "street", "postcode"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "country") {
                try {
                    const response = await getStateData(option.key)
                    setStateData(response)
                    setCityData([])
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "state"
                    );
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "state") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "state",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    setStateData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "state") {
                try {
                    const response = await getCityData(option.key)
                    setCityData(response)
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "city") {
                try {
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "street") {
                try {
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const FIELDTYPE_VALIDATOR_MAP = {
        String: (value) => nameOnChangeValidator(value, 20),
        Number: (value) => validateNumberField(value),
        Currency: (value, currencySettings) => validateCurrencyField(value, currencySettings?.decimalOfCurrency ?? 2),
        Percentage: (value, currencySettings) => validatePercentageField(value, currencySettings?.decimalOfCurrency ?? 2),
        LongString: (value) => validateDescriptionField(value, 2500)
    };
    const FIELD_VALIDATOR_MAP = {
        phone: (value) => mobileOnChangeValidator(value, 20),
        fax: (value) => mobileOnChangeValidator(value, 20),
        mobile: (value) => mobileOnChangeValidator(value, 20),
        accountName: (value) => nameOnChangeValidator(value, 50),
        designation: (value) => nameOnChangeValidator(value, 50),
        street: (value) => nameOnChangeValidator(value, 100),
        postcode: (value) => validateZipCode(value, 25),
        website: (value) => validateUrlField(value, 2000),
        primaryEmail: (value) => validateEmailField(value, 50),
        secondaryEmail: (value) => validateEmailField(value, 50),
    };
    const handleValidatedChange = (index, fieldName, value, key, fieldKey, option) => {
        let error = null;
        if (FIELD_VALIDATOR_MAP[fieldKey]) {
            error = FIELD_VALIDATOR_MAP[fieldKey](value, defaultCurrency);
        } else if (FIELDTYPE_VALIDATOR_MAP[fieldKey]) {
            error = FIELDTYPE_VALIDATOR_MAP[fieldKey](value, defaultCurrency);
        }
        if (error) {
            message.error(error);
            return;
        }
        handleViewChange(index, fieldName, value, key, option);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.fieldKey) || selectBoxes[currentIndex].editedField === option.fieldKey);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.fieldKey === fieldValue);
        return field ? field.fieldType : null;
    }
    const leadOwnerField = editAttributes.find(
        (item) => item.fieldKey === "leadOwner"
    );
    return (
        <>
            <Modal
                title={popupType}
                open={popup}
                onCancel={handleClose}
                // width={700}
                maskClosable={false}
                footer={uiReady ? [
                    <div>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' size="small" onClick={onFromSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" size="small" className='btn-add_new button_colors' onClick={onFromSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }
                        {(popupType === "Bulk Delete" || popupType === "Bulk Convert" || popupType === "Delete" || popupType === "Convert") &&
                            <>
                                {!open ?
                                    <>
                                        <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                            <CancelIcon /> Cancel
                                        </Button>
                                        <Button htmlType="submit" size="small" onClick={onSubmit} loading={deleteClick} disabled={deleteClick} className={popupType === "Bulk Convert" || popupType === "Convert" ? "button_colors" : "red-button"}>
                                            {!deleteClick && (popupType === "Bulk Convert" || popupType === "Convert" ? <ConvertIcon /> : <DeleteIcon />)}{popupType}
                                        </Button>
                                    </>
                                    :
                                    <>
                                        <Button htmlType="submit" size="small" className='button_colors' onClick={handleClose}>
                                            Ok
                                        </Button>
                                    </>}
                            </>}
                    </div>
                ] : false}
            >
                {uiReady ? <> {popupType === "Bulk Update" &&
                    (editAttributes.length ? <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="LeadMassUpdate" colon={false} >
                                    {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                        const filedType = getFieldTypeByValue(selectbox.editedField)
                                        return (
                                            <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                <Col span={10}>
                                                    <Form.Item >
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Field"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            value={selectbox.editedField}
                                                            onChange={(record, option) => {
                                                                const Key = option.FieldType
                                                                handleViewChange(index, 'editedField', record, Key);
                                                            }}
                                                            disabled={index !== 0}
                                                        >
                                                            {getAvailableOptions(index).map((option, idx) => (
                                                                <Option value={option.fieldKey} key={idx} FieldType={option.fieldType}>
                                                                    {option.fieldLabel}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={14} style={filedType === 'CheckBox' ? { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } : {}}>
                                                    <Form.Item key={index}>
                                                        {filedType === 'Dropdown' ? (DEFAULT_DROPDOWN_FIELDS.includes(selectbox.editedField) ? (
                                                            selectbox.editedField === "accountName" ?
                                                                <AutoComplete
                                                                    options={account2}
                                                                    value={selectbox.editedValue}
                                                                    onSelect={(value) => handleValidatedChange(index, 'editedValue', value, filedType, selectbox.editedField)}
                                                                    onChange={(value) => handleValidatedChange(index, 'editedValue', value, filedType, selectbox.editedField)}
                                                                    style={{ width: '100%' }}
                                                                    placeholder="Type or select an option"
                                                                    filterOption={(inputValue, option) =>
                                                                        option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                                    }
                                                                >
                                                                    <Input />
                                                                </AutoComplete>
                                                                :
                                                                <Select placeholder="Select Value"
                                                                    showSearch
                                                                    style={{ width: "100%" }}
                                                                    optionFilterProp="children"
                                                                    {...(selectbox.editedField === "leadOwner"
                                                                        ? { optionLabelProp: "label" } : {})}
                                                                    filterOption={(input, option) =>
                                                                        (selectbox.editedField === "leadOwner")
                                                                            ? (() => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            })()
                                                                            : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    name="editedValue"
                                                                    value={selectbox.editedValue}
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value, filedType, option);
                                                                    }}
                                                                >
                                                                    {(selectbox.editedField === "leadOwner") &&
                                                                        users.filter(item => item.department === "Sales").map((option, i) => (
                                                                            <Option value={option.userId}
                                                                                label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                    < img src={option.profilePic} alt="profile" />
                                                                                                    :
                                                                                                    <span className="image_icon UserIcon">
                                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }
                                                                                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                key={i}>
                                                                                <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                    <div>
                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                            < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }</div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                        <p style={{ margin: 0 }}>{option.username}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Option>))
                                                                    }
                                                                    {selectbox.editedField === "country" &&
                                                                        <>
                                                                            {allCountry}
                                                                        </>}
                                                                    {selectbox.editedField === "state" &&
                                                                        <>
                                                                            {stateData?.map((option) => (
                                                                                <Option key={option.stateId} value={option.state}>
                                                                                    {option.state}
                                                                                </Option>
                                                                            ))}
                                                                        </>}
                                                                    {selectbox.editedField === "city" &&
                                                                        <>
                                                                            {cityData?.map((option) => (
                                                                                <Option key={option.cityId} value={option.city}>
                                                                                    {option.city}
                                                                                </Option>
                                                                            ))}
                                                                        </>}
                                                                </Select>
                                                        ) : (
                                                            !dropdownLoading[selectbox.editedField] ?
                                                                <Select
                                                                    placeholder="Select Value"
                                                                    showSearch
                                                                    style={{ width: "100%" }}
                                                                    optionFilterProp="children"
                                                                    value={selectbox.editedValue}
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value, filedType, option);
                                                                    }}
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {(dropdownOptions[selectbox.editedField] || []).map((opt, i) => (
                                                                        <Option key={i} value={opt.customDropdownOptionId}>
                                                                            {opt.option}
                                                                        </Option>
                                                                    ))}
                                                                </Select> :
                                                                <div>
                                                                    <Skeleton.Input style={{ width: "100%" }} active />
                                                                </div>
                                                        )) :
                                                            filedType === 'Multi-Dropdown' ?
                                                                (!dropdownLoading[selectbox.editedField] ? <Select
                                                                    mode="multiple"
                                                                    className="MultiUiNew"
                                                                    style={{ width: '100%' }}
                                                                    placeholder="Select Value"
                                                                    showSearch value={selectbox.editedValue}
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, opt) =>
                                                                        opt.children.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value, filedType, option);
                                                                    }}
                                                                >
                                                                    {(dropdownOptions[selectbox.editedField] || []).map((opt, i) => (
                                                                        <Option key={i} value={opt.customDropdownOptionId}>
                                                                            {opt.option}
                                                                        </Option>
                                                                    ))}
                                                                </Select> :
                                                                    <div>
                                                                        <Skeleton.Input style={{ width: "100%" }} active />
                                                                    </div>) :
                                                                filedType === 'CheckBox' ? <>
                                                                    <Checkbox checked={selectbox.editedValue} onChange={(e) => handleValidatedChange(index, 'editedValue', e.target.checked, filedType, selectbox.editedField)} />
                                                                    <span style={{ marginLeft: 5 }}>{selectbox.editedValue ? "Yes" : "No"}</span></>
                                                                    :
                                                                    filedType === 'String' ? (
                                                                        (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                            name="editedValue" maxLength={50}
                                                                            value={selectbox.editedValue}
                                                                            onChange={(e) => {
                                                                                handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                            }} />
                                                                        ))
                                                                        : filedType === 'Number' ? (
                                                                            (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                name="editedValue" maxLength={25}
                                                                                value={selectbox.editedValue}
                                                                                onChange={(e) => {
                                                                                    handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                }} />
                                                                            ))
                                                                            : filedType === 'Currency' ? (
                                                                                (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                    name="editedValue"
                                                                                    value={selectbox.editedValue}
                                                                                    prefix={defaultCurrency?.symbol || '$'}
                                                                                    onChange={(e) => {
                                                                                        handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                    }} />
                                                                                ))
                                                                                : filedType === 'Percentage' ? (
                                                                                    (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                                        name="editedValue"
                                                                                        value={selectbox.editedValue} prefix="%" min={0} max={100}
                                                                                        onChange={(e) => {
                                                                                            handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                        }} />
                                                                                    ))
                                                                                    : filedType === 'Date' ? (
                                                                                        (<DatePicker
                                                                                            allowClear={false}
                                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                            placeholder="Enter Value" style={{ width: "100%" }}
                                                                                            name="editedValue"
                                                                                            value={selectbox.editedValue ? moment(selectbox.editedValue, "YYYY-MM-DD") : null}
                                                                                            onChange={(date) => {
                                                                                                handleValidatedChange(index, 'editedValue', date ? date.format("YYYY-MM-DD") : null, filedType, selectbox.editedField);
                                                                                            }} />
                                                                                        ))
                                                                                        : filedType === 'LongString' ? (
                                                                                            (<Input.TextArea placeholder="Enter Value" style={{ width: "100%" }}
                                                                                                rows={3} maxLength={2500}
                                                                                                showCount
                                                                                                name="editedValue"
                                                                                                value={selectbox.editedValue}
                                                                                                onChange={(e) => {
                                                                                                    handleValidatedChange(index, 'editedValue', e.target.value, filedType, selectbox.editedField);
                                                                                                }} />
                                                                                            ))
                                                                                            : ""
                                                        }
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )
                                    })}
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100px" }}>
                            <Empty />
                        </div>)
                }
                    {popupType === "Change Owner" &&
                        (editAttributes.length ? <AddUser>
                            <div className="user-info-form">
                                <BasicFormWrapper>
                                    <Form style={{ width: '100%' }} form={form} name="Assignto" colon={false} >
                                        <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                            <Col span={10}>
                                                <Form.Item>
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Field"
                                                        showSearch
                                                        disabled
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        value={leadOwnerField?.fieldId}
                                                    >
                                                        {editAttributes?.map((option, key) => (
                                                            <Option key={key} value={option.fieldId}>
                                                                {option.fieldLabel}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={14}>
                                                {leadOwnerField?.fieldKey === "leadOwner" &&
                                                    <Form.Item name="leadOwner" id="leadOwner">
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Lead Owner"
                                                            showSearch optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            }
                                                            onChange={handleLeadOwner}>
                                                            {users.filter(item => item.department === "Sales").map((option, i) => (
                                                                <Option value={option.userId}
                                                                    label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon UserIcon">
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    key={i}>
                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`} >
                                                                        <div>
                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                :
                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            }</div>
                                                                        <div>
                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                        </div>
                                                                    </div>
                                                                </Option>))}
                                                        </Select>
                                                    </Form.Item>}
                                            </Col>
                                        </Row>
                                    </Form>
                                </BasicFormWrapper>
                            </div>
                        </AddUser> :
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100px" }}>
                                <Empty />
                            </div>)
                    }
                    {(popupType === "Bulk Delete" || popupType === "Bulk Convert" || popupType === "Delete" || popupType === "Convert") &&
                        <div style={{ padding: "0px 20px" }}>
                            {!open ?
                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                    {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected leads?</p>}
                                    {popupType === "Bulk Convert" && <p>Are you sure you want to convert the selected leads into contacts?</p>}
                                    {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                                    {popupType === "Convert" && <p> Are you sure you want to convert this lead into a contact?</p>}
                                </div>
                                : <></>
                            }
                        </div>}</> :
                    <div className="spin" style={{ height: "150px" }}>
                        <Spin />
                    </div>}
            </Modal>
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Lead" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Lead" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    popup: PropTypes.bool.isRequired,
    setPopup: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    action: PropTypes.string.isRequired,
    setStates: PropTypes.func.isRequired,
    assignOwner: PropTypes.number.isRequired,
    pageType: PropTypes.string.isRequired,
    successMessage: PropTypes.func.isRequired,
};

export default Popup;
